import React, { useState, useEffect,  useContext , useRef } from "react";
import PricingSection from "./PricingSection";
import FaQ from "./FaQ";
import CtaSection from "./CtaSection";
import LandingNav from "../Landing_Nav";
import LandingFooter from "../Landing_Footer";
import { useLocation } from "react-router-dom";
import MyContext from "../../../MyContext";

const PricingPage = () => {
  const location = useLocation();
const { openFreeTrialModal } = useContext(MyContext);

  useEffect(() => {
  const pageKey = location.pathname;
  const storageKey = `freeTrialClosed_${pageKey}`;

  if (!sessionStorage.getItem(storageKey)) {
    openFreeTrialModal(pageKey);
  }

  return () => {
    sessionStorage.removeItem(storageKey);
  };
}, [location.pathname]);


  return (
    <>
      <LandingNav />
      <PricingSection />
      <FaQ />
      <CtaSection />
      <LandingFooter />
    </>
  );
};

export default PricingPage;
